// Shared public data: navigation, quote form options, SEO per route.

export const TRAITEUR_SUBMENU = [
  { label: "Mariages et cérémonies", to: "/mariages" },
  { label: "Événements privés", to: "/traiteur#prives" },
  { label: "Entreprises et institutions", to: "/traiteur#entreprises" },
  { label: "Catering et production", to: "/catering-production" },
  { label: "Nos menus & cartes", to: "/menus" },
];

export const EVENT_TYPES = [
  "Mariage ou cérémonie",
  "Événement privé",
  "Entreprise ou institution",
  "Association, événement culturel ou sportif",
  "Production, tournage ou spectacle",
  "Autre",
];

export const PRESTATIONS = [
  "Traiteur uniquement",
  "Coordination événementielle uniquement",
  "Traiteur et coordination",
  "Cheffe à domicile",
  "Je souhaite être conseillée",
];

export const FORMATS = [
  "Cocktail, vin d'honneur ou apéritifs uniquement",
  "Repas uniquement",
  "Cocktail suivi d'un repas",
  "Buffet",
  "Service à l'assiette",
  "Je souhaite être conseillée",
];

export const CUISINES = [
  "Africaine",
  "Cuisine des îles",
  "Française",
  "Mixte",
  "Je souhaite être conseillée",
];

export const COORDINATION_TYPES = [
  "Coordination du jour J uniquement",
  "Préparation et coordination du jour J",
  "Accompagnement personnalisé",
  "Je souhaite être conseillée",
];

export const CHEF_OCCASIONS = [
  "Dîner romantique en couple",
  "Anniversaire ou occasion spéciale",
  "Dîner entre amis à domicile",
  "Repas privé dans une ambiance chaleureuse",
  "Dîner privé premium ou VIP",
  "Projet sur mesure",
];

export const GALLERY_CATEGORIES = [
  { value: "mariages", label: "Mariages et cérémonies" },
  { value: "prives", label: "Événements privés" },
  { value: "entreprises", label: "Entreprises, institutions et inaugurations" },
  { value: "catering", label: "Catering, spectacles et productions" },
];

export const BLOG_CATEGORIES = [
  { value: "mariages", label: "Mariages et réceptions" },
  { value: "professionnels", label: "Événements professionnels et institutionnels" },
  { value: "catering", label: "Catering et production" },
  { value: "cuisine", label: "Cuisine et art de recevoir" },
];

export const QUOTE_STATUSES = [
  { value: "nouvelle", label: "Nouvelle demande", color: "#C9A84C" },
  { value: "a_contacter", label: "À contacter", color: "#C98A3C" },
  { value: "en_cours", label: "En cours", color: "#4A7FB0" },
  { value: "devis_envoye", label: "Devis envoyé", color: "#6B8E4E" },
  { value: "relance", label: "Relance à effectuer", color: "#B0763C" },
  { value: "confirmee", label: "Confirmée", color: "#2E7D32" },
  { value: "refusee", label: "Refusée ou abandonnée", color: "#9E9E9E" },
];

export function statusMeta(value) {
  return QUOTE_STATUSES.find((s) => s.value === value) || QUOTE_STATUSES[0];
}

// Fallback ambiance images (clearly labelled "visuel d'ambiance", never presented as real realizations)
export const AMBIANCE = {
  hero: "https://images.unsplash.com/photo-1719499683843-721331f2495f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  traiteur: "https://images.unsplash.com/photo-1555244162-803834f70033?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwd2VkZGluZyUyMGNhdGVyaW5nfGVufDB8fHx8MTc5MjM1NTgzOHww&ixlib=rb-4.1.0&q=85&w=900",
  chef: "https://images.pexels.com/photos/36904788/pexels-photo-36904788.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=900",
  coordination: "https://images.pexels.com/photos/35985211/pexels-photo-35985211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=900",
  pro: "https://images.pexels.com/photos/30892994/pexels-photo-30892994.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=900",
  portfolio: [
    "https://images.pexels.com/photos/5491046/pexels-photo-5491046.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=900",
    "https://images.unsplash.com/photo-1502635385003-ee1e6a1a742d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    "https://images.pexels.com/photos/35985211/pexels-photo-35985211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=900",
    "https://images.unsplash.com/photo-1555244162-803834f70033?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  ],
};


export const SITE_IMAGES = [
  { page: "Accueil", key: "home_hero", label: "Image principale (hero)", def: "/images/accueil-ambiance.jpg" },
  { page: "Accueil", key: "home_traiteur", label: "Carte « Traiteur événementiel »", def: AMBIANCE.traiteur },
  { page: "Accueil", key: "home_chef", label: "Carte « Cheffe à domicile »", def: AMBIANCE.chef },
  { page: "Accueil", key: "home_coordination", label: "Carte « Coordination événementielle »", def: AMBIANCE.coordination },
  { page: "Accueil", key: "home_pro", label: "Section « Professionnels »", def: AMBIANCE.pro },
  { page: "Mariages & cérémonies", key: "mariage_hero", label: "Image d'en-tête", def: "/images/mariage-hero.jpg" },
  { page: "Mariages & cérémonies", key: "mariage_cocktail", label: "Section « Cocktail & vin d'honneur »", def: "/images/mariage-cocktail.jpg" },
  { page: "Mariages & cérémonies", key: "mariage_cuisine", label: "Section « Nos cuisines »", def: "/images/mariage-cuisine.jpg" },
  { page: "Traiteur", key: "traiteur_hero", label: "Image d'en-tête", def: AMBIANCE.traiteur },
  { page: "Catering & production", key: "catering_hero", label: "Image d'en-tête (tournage)", def: "/images/catering-tournage.jpg" },
  { page: "Catering & production", key: "catering_concert", label: "Section « Ce que nous proposons » (concert)", def: "/images/catering-concert.jpg" },
  { page: "Catering & production", key: "catering_sport", label: "Section « Pourquoi Afro Regal » (sport)", def: "/images/catering-sport.jpg" },
  { page: "Cheffe à domicile", key: "chef_slide_1", label: "Slider — image 1 (dîner romantique)", def: "/images/cheffe-couple.jpg" },
  { page: "Cheffe à domicile", key: "chef_slide_2", label: "Slider — image 2 (entre amis)", def: "/images/cheffe-amis.jpg" },
  { page: "Cheffe à domicile", key: "chef_slide_3", label: "Slider — image 3 (en famille)", def: "/images/cheffe-famille.jpg" },
  { page: "Cheffe à domicile", key: "chef_hero", label: "Image de la section « Positionnement »", def: AMBIANCE.chef },
  { page: "Cheffe à domicile", key: "chef_section", label: "Image de la section « Occasions »", def: AMBIANCE.coordination },
  { page: "Coordination événementielle", key: "coordination_hero", label: "Image d'en-tête", def: AMBIANCE.coordination },
  { page: "Coordination événementielle", key: "coordination_terrain", label: "Photo « Sur le terrain »", def: "/amalya.png" },
  { page: "Nos réalisations", key: "realisations_hero", label: "Image d'en-tête", def: AMBIANCE.portfolio[0] },
  ...AMBIANCE.portfolio.map((def, i) => ({ page: "Nos réalisations", key: `ambiance_${i + 1}`, label: `Visuel d'ambiance ${i + 1} (affiché si la galerie est vide, aussi sur l'accueil)`, def })),
  { page: "La carte", key: "menus_hero", label: "Image d'en-tête", def: AMBIANCE.traiteur },
  { page: "À propos", key: "apropos_hero", label: "Image d'en-tête", def: AMBIANCE.pro },
  { page: "Le Journal (blog)", key: "blog_hero", label: "Image d'en-tête", def: AMBIANCE.pro },
];

export const AMBIANCE_KEYS = AMBIANCE.portfolio.map((_, i) => `ambiance_${i + 1}`);
